





















import { Vue, Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {
  ProductInstanceResult,
  AdminUserResult
} from "@futuri/cloudsso-client";

@Component
export default class UserGeneral extends Vue {
  @Getter("cachedInstances", { namespace: "adminUserPost" })
  instances?: ProductInstanceResult[];

  @Getter("currentUser", { namespace: "adminUserPost" })
  currentUser?: AdminUserResult;
  @Getter("currentCompany", { namespace: "adminUserPost" })
  currentCompany?: string;

  get displayEmail() {
    return this.currentUser?.email;
  }
  get displayCompany() {
    return this.currentCompany;
  }

  get headers() {
    return [
      { label: "Product" },
      { label: "☑ Enabled" },
      { label: "Seats available (company)" }
    ];
  }

  get items() {
    const createCheckbox = (checked = false): HTMLInputElement => {
      const el = document.createElement("input");
      el.setAttribute("type", "checkbox");
      if (checked) {
        el.setAttribute("checked", "checked");
      }
      return el;
    };

    const items = [
      {
        Product: "POST",
        "☑ Enabled": createCheckbox(true),
        "Seats available (company)": 24
      },
      {
        Product: "TopLine",
        "☑ Enabled": createCheckbox(true),
        "Seats available (company)": 12
      },
      {
        Product: "TopicPulse",
        "☑ Enabled": createCheckbox(true),
        "Seats available (company)": 12
      }
    ];

    return items;
  }
}
